import classnames from 'classnames';
import * as React from 'react';
import * as style from './Month.css';

type ITMonthProps = {
  label: string;
  value: string;
  checked?: string;
  handleChecked: (value: string) => void;
};

export const Month: React.FC<ITMonthProps> = ({ label, value, checked = '', handleChecked }) => {
  return (
    <div className={style['month']}>
      <div
        className={classnames(style['month-label'], checked === value && style['month-label-checked'])}
        onClick={() => handleChecked(value)}
      >
        {label}
      </div>
    </div>
  );
};
